// extracted by mini-css-extract-plugin
module.exports = {"layout":"quotation_layout___3Bqt","avatarContainer":"quotation_avatarContainer__QXUuU","quote":"quotation_quote__eY1Su"};